import React from 'react';
import i18n from '../../../i18n';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Chunk load error:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: '20px',
            textAlign: 'center',
            fontFamily: 'inherit',
          }}
        >
          <h2 style={{ fontSize: '28px', margin: '0 0 16px 0', color: '#222' }}>
            {i18n.t('errorBoundary.title')}
          </h2>
          <p
            style={{
              fontSize: '16px',
              color: '#555',
              maxWidth: '480px',
              lineHeight: '1.5',
              margin: '0 0 32px 0',
            }}
          >
            {i18n.t('errorBoundary.message')}
          </p>
          <button
            onClick={this.handleRetry}
            style={{
              padding: '12px 32px',
              fontSize: '16px',
              cursor: 'pointer',
              border: '1px solid #333',
              borderRadius: '4px',
              background: '#fff',
              color: '#222',
            }}
          >
            {i18n.t('errorBoundary.retry')}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
